import { render, staticRenderFns } from "./QuickAddChangeSummary.vue?vue&type=template&id=58235dcf&scoped=true"
import script from "./QuickAddChangeSummary.vue?vue&type=script&lang=js"
export * from "./QuickAddChangeSummary.vue?vue&type=script&lang=js"
import style0 from "./QuickAddChangeSummary.vue?vue&type=style&index=0&id=58235dcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58235dcf",
  null
  
)

export default component.exports